import { render } from "./ProductPrice.vue?vue&type=template&id=47089f7a&ts=true"
import script from "./ProductPrice.vue?vue&type=script&lang=ts"
export * from "./ProductPrice.vue?vue&type=script&lang=ts"

import "./ProductPrice.vue?vue&type=style&index=0&id=47089f7a&lang=css"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__